import { Injectable } from '@angular/core';
import { emoji2017Items } from './emoji2017';
import { Emoji } from '../../_modules/emoji-picker/emoji';
import { environment } from '../../../environments/environment';
import { emojiDuoFuXiong } from './duofuxiong';
import { emojiHuHu } from './huhu';
import { emojiJiDaBai } from './jidabai';
import { emojiMiaoHun } from './miaohun';
import { emojiPiLiTu } from './pilitu';
import { emojiQiuQiu } from './qiuqiu';
import { emojiTianXingTu } from './tianxingtu';
import { emojiTuBaiBai } from './tubaibai';
import { Utility } from '../utility';

@Injectable()
export class DnEmojiService {
  isAdult = environment.cinema === 2;

  emojiDic = [
    emoji2017Items,
    emojiDuoFuXiong,
    emojiHuHu,
    emojiJiDaBai,
    emojiMiaoHun,
    emojiPiLiTu,
    emojiQiuQiu,
    emojiTianXingTu,
    emojiTuBaiBai
  ]
  constructor(private _utility:Utility) {
  }
  public getEmojiItems(): Object {
    return this.transform(emoji2017Items);
  }
  // 多福熊
  public getEmojiDuoFuXiong(): Object {
    return this.transform(emojiDuoFuXiong);
  }
  public getEmojiHuHu(): Object {
    return this.transform(emojiHuHu);
  }
  public getEmojiJiDaBai(): Object {
    return this.transform(emojiJiDaBai);
  }
  public getEmojiMiaoHun(): Object {
    return this.transform(emojiMiaoHun);
  }
  public getEmojiPiLiTu(): Object {
    return this.transform(emojiPiLiTu);
  }
  public getEmojiQiuQiu(): Object {
    return this.transform(emojiQiuQiu);
  }
  public getEmojiTianXingTu(): Object {
    return this.transform(emojiTianXingTu);
  }
  public getEmojiTuBaiBai(): Object {
    return this.transform(emojiTuBaiBai);
  }

  transform(source) {
    const res = {
      label: source.label,
      height: source.height,
      width: source.width,
      items: []
    };

    for(let i = 0;i<source.range.length;++i)
    {
      let range = source.range[i];
      for(let j =range[0];j<range[1]+1;++j)
      {
        res.items.push(<Emoji>{
          id:j,
          image:`${source.path}${j}.gif`,
          imageHost: 'https://static.' + this._utility.GetHost(''),
          title:`(:${j})`,
          symbol:`(:${j})`
        })
      }
    }
    return res;
  }
  

  getImageFromSymbol(symbol) {
    let id = parseInt(symbol.replace("(:","").replace(")",""));
    let find = this.getById(id);

    if(find == null)
    {
      return ''
    }

    return `<img src="${'https://static.' + this._utility.GetHost('')}${find.path}${id}.gif" title="(:${id})" />`
    // const emojis = [
    // ...this.transform(emoji2017Items).items,
    // ...this.transform(emojiDuoFuXiong).items,
    // ...this.transform(emojiHuHu).items,
    // ...this.transform(emojiJiDaBai).items,
    // ...this.transform(emojiMiaoHun).items,
    // ...this.transform(emojiPiLiTu).items,
    // ...this.transform(emojiQiuQiu).items,
    // ...this.transform(emojiTianXingTu).items,
    // ...this.transform(emojiTuBaiBai).items,
    // ];
    // const res = emojis.filter(item => item.symbol === symbol);
    // if (res.length) {
    //   return Object.assign(new Emoji(), res[0]).html;
    // }
    // return '';
  }

  private getById(id:number)
  {
    let index = this.emojiDic.findIndex(p=>{
      for(let i =0;i<p.range.length;++i)
      { 
        let range = p.range[i];
        if ((range[0] < id && range[1] >= id) || (range[0] <= id && range[1] > id)) {
          return true;
        }
      } 
      return false;
    });
    return index>-1?this.emojiDic[index]:null;
  }
  getSymbolFromImage(image) {

    let id = parseInt(image.replace(/^.*[\\\/]/, ''));
    var find = this.getById(id);
    return find !=null ?`(:${id})`:""
  
  }

  public emojiString2Html(content: string): string {
    const emojiRegex = /\(:\d*?\)/gi;
    const matches = content.match(emojiRegex);
    if (matches) {
      matches.forEach(element => {
        const image = this.getImageFromSymbol(element);
        content = content.replace(element, image);
      });
    }
    return content;
  }
  stripHtml(html) {
    const lineBreak = "\n";
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html.replace(/<br>/g, lineBreak);
    const result = tmp.textContent || tmp.innerText || "";
    return result;
  }
  public emojiHtml2String(content: string): string {
    const emojiRegex = /<img.*?src="(.*?)">/gi;
    const matches = content.match(emojiRegex);
    if (matches) {
      matches.forEach(element => {
        const valueRegex = /src="(.*?)"/;
        const valueMatches = element.match(valueRegex);
        if (valueMatches) {
          const value = valueMatches[1];
          const image = this.getSymbolFromImage(value);
          content = content.replace(element, image);
        }
      });
    }
    return this.stripHtml(content);
  }
}
